import { Component, EventEmitter, Inject, OnDestroy, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InventoryService } from '@wb/core/services/inventory.service';
import { AnalyticService } from '@wb/core/services/analytic.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-price-reset-dialog',
  templateUrl: './price-reset-dialog.component.html',
  styleUrls: ['./price-reset-dialog.component.sass'],
})
export class PriceResetDialogComponent implements OnDestroy {
  @Output() save: EventEmitter<void> = new EventEmitter();

  formGroup: FormGroup = new FormGroup({
    price_msrp: new FormControl(null),
    price_advert: new FormControl(null),
    price_web: new FormControl(null),
    price_invoice: new FormControl(null),
    price_variable: new FormControl(null),
    price_after_incentives: new FormControl(null),
    price_wholesale: new FormControl(null),
  });

  isLoadingData: boolean = true;

  private destroyed$: Subject<void> = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { accountUid: string; userUid: string; inventory: InventoryService },
    public dialogRef: MatDialogRef<PriceResetDialogComponent>,
    private inventoryService: InventoryService,
    private analytics: AnalyticService,
  ) {
    this.isLoadingData = false;
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  async onSubmit() {
    const priceList = {
      price_msrp: this.formGroup.value.price_msrp ?? false,
      price_advert: this.formGroup.value.price_advert ?? false,
      price_invoice: this.formGroup.value.price_invoice ?? false,
      price_variable: this.formGroup.value.price_variable ?? false,
      price_web: this.formGroup.value.price_web ?? false,
      price_wholesale: this.formGroup.value.price_wholesale ?? false,
      price_after_incentives: false, // TODO Add to the UI Later if needed
    };

    this.inventoryService
      .priceReset(this.data.accountUid as string, this.data.userUid as string, priceList)
      .then((response) => {
        if (!(response instanceof HttpErrorResponse)) {
          this.data.inventory.refetchInventory();
          this.dialogRef.close(true);
        }
      });
    this.analytics.track({ object: 'Inventory', action: 'Click', properties: { type: 'submit_price_reset' } });
  }
}
